<template>
    <v-container class="ma-0 pa-0">
        <v-row v-if="!loading" >
            <v-col cols="12">
                <v-menu
                    ref="datePickerMenu"
                    :close-on-content-click="false"
                    v-model="dailyHusbandryPickerMenu"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            clearable
                            slot="activator"
                            v-model="displayHusbandryDate"
                            label="Husbandry Date"
                            prepend-icon="event"
                            hint="Husbandry Date"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker 
                        v-model="husbandryDate"
                        @input="dailyHusbandryPickerMenu = false"
                        :title-date-format="datePickerFormat"
                    >
                    </v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols="12" md="6">
                <span class="title">Tasks</span>
                <v-checkbox 
                    hide-details
                    v-for="task in tasks"
                    v-model="selectedTasks"
                    :key="task.DailyHusbandryTaskTypeID"
                    :label="task.DailyHusbandryTaskTypeName"
                    :value="task.DailyHusbandryTaskTypeID"></v-checkbox>
            </v-col>
            <v-col cols="12" md="6">
                <span class="title">Observations</span>
                <v-checkbox 
                    hide-details
                    v-for="obs in observations"
                    v-model="selectedObservations"
                    :key="obs.DailyHusbandryObservationTypeID"
                    :label="obs.DailyHusbandryObservationTypeName"
                    :value="obs.DailyHusbandryObservationTypeID"></v-checkbox>
            </v-col>
            <v-col cols="12" md="6" offset-md="3" lg="4" offset-lg="4" v-if="newWeightRequired">
                <NumericEntry
                    v-model="newWeight"
                    label="New Weight"
                    :rules="[]"
                    v-bind="newWeightConfig"
                    suffix="g">
                </NumericEntry>
            </v-col>
            <v-col cols="12" md="6" offset-md="3" lg="4" offset-lg="4" v-if="newLocationRequired">
                <v-select
                    :items="activeLocationTypes"
                    item-text="Text"
                    item-value="LocationTypeID"
                    v-model="newLocationTypeID"
                    label="New Location Type"
                    :rules="[]"
                ></v-select>
            </v-col>
            <v-col cols="12" md="6" offset-md="3" lg="4" offset-lg="4" v-if="newLocationRequired">
                <v-select
                    :items="activeRooms"
                    item-text="Text"
                    item-value="RoomID"
                    v-model="newRoomID"
                    label="New Room"
                    :rules="[]"
                ></v-select>
            </v-col>
            <v-col cols="12" md="6" offset-md="3" lg="4" offset-lg="4" v-if="newLocationRequired">
                <v-select
                    :items="activeSuiteNumbers"
                    item-text="Text"
                    item-value="SuiteNumberID"
                    v-model="newSuiteNumberID"
                    label="New Suite Number"
                    :rules="[]"
                ></v-select>
            </v-col>
            <v-col cols="12" md="6" offset-md="3" lg="4" offset-lg="4" v-if="newLocationRequired">
                <v-text-field
                    v-model="newRackNumber"
                    label="Rack Number"
                    counter="200"
                    maxlength="200"
                >
                </v-text-field>
            </v-col>
            <v-col cols="12" md="6" offset-md="3" lg="4" offset-lg="4" v-if="newLocationRequired">
                <v-select
                    :items="activeDrawers"
                    item-text="Text"
                    item-value="DrawerID"
                    v-model="newDrawerID"
                    label="New Drawer"
                    :rules="[]"
                ></v-select>
            </v-col>
            <v-col cols="12" v-if="dangerousOtherRequired">
                <v-textarea
                    filled
                    counter="8000"
                    maxlength="8000"
                    v-model="dangerousOtherText"
                    label="Comments"></v-textarea>
            </v-col>
            <v-col cols="12">
                <div class="text-center">
                    <v-btn color="success" :disabled="!validHusbandry" @click="submitDailyHusbandry" :loading="saving">Save</v-btn>
                </div>
            </v-col>
            <v-col cols="12" v-if="saveError">
                <v-alert text type="error">{{ saveError }}</v-alert>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import constants from 'comunet-btg-utah-repository-shared/constants';
import NumericEntry from "../common/NumericEntry";
import { mapGetters } from 'vuex';

import moment from 'moment';

export default {
    components: {
        NumericEntry
    },
    props: [
        // This has been disabled in the initial lint setup - if you are working on this page please determine the correct type for these properties
        //eslint-disable-next-line
        "specimenID",
        // This has been disabled in the initial lint setup - if you are working on this page please determine the correct type for these properties
        //eslint-disable-next-line
        "currentLocationTypeID",
        // This has been disabled in the initial lint setup - if you are working on this page please determine the correct type for these properties
        //eslint-disable-next-line
        "currentRoomID",
        // This has been disabled in the initial lint setup - if you are working on this page please determine the correct type for these properties
        //eslint-disable-next-line
        "currentDrawerID",
        // This has been disabled in the initial lint setup - if you are working on this page please determine the correct type for these properties
        //eslint-disable-next-line
        "currentSuiteNumberID",
        // This has been disabled in the initial lint setup - if you are working on this page please determine the correct type for these properties
        //eslint-disable-next-line
        "currentRackNumber",
    ],
    data() {
        return {
            dailyHusbandryPickerMenu: false,
            selectedTasks: [],
            selectedObservations: [],
            dangerousOtherText: "",
            newWeight: null,
            newWeightConfig: {
                decimalPlaces: 2,
                minValue: 0,
                maxValue: 999999
            },
            newLocationTypeID: this.currentLocationTypeID,
            newRoomID: this.currentRoomID,
            newDrawerID: this.currentDrawerID,
            newSuiteNumberID: this.currentSuiteNumberID,
            newRackNumber: this.currentRackNumber,
            husbandryDate: moment().format(constants.DATE_PICKER_FORMAT)
        };
    },
    computed: {
        ...mapGetters({
            activeLocationTypes: "locationStore/activeLocationTypes",
            activeSuiteNumbers: "locationStore/activeSuiteNumbers",
            activeRooms: "locationStore/activeRooms",
            activeDrawers: "locationStore/activeDrawers",
            locationsLoading: "locationStore/loading"
        }),
        displayHusbandryDate: {
            get: function() {
                if (this.husbandryDate) {
                    return moment.utc(this.husbandryDate).format(constants.DATE_FORMAT_NO_TIME);
                }
                
                return "";
            },
            set: function(newValue) {
                this.husbandryDate = newValue;
            }
        },
        loading() {
            return this.$store.state.dailyHusbandryStore.tasksLoading ||
                this.$store.state.dailyHusbandryStore.observationsLoading ||
                this.locationsLoading;
        },
        tasks() {
            return this.$store.state.dailyHusbandryStore.dailyHusbandryTaskTypes;
        },
        observations() {
            return this.$store.state.dailyHusbandryStore.dailyHusbandryObservationTypes;
        },
        newWeightRequired() {
            return this.selectedTasks.includes(constants.DAILY_HUSBANDRY_TYPES.UPDATE_WEIGHT);
        },
        newLocationRequired() {
            return this.selectedTasks.includes(constants.DAILY_HUSBANDRY_TYPES.UPDATE_LOCATION);
        },
        dangerousOtherRequired() {
            var that = this;
            return this.selectedObservations.some(function(element){
                return that.$store.state.dailyHusbandryStore.dailyHusbandryObservationTypes.some(x => x.DailyHusbandryObservationTypeID == element && x.RequiresNotes == 1)
            });
        },
        validHusbandry() {
            return !this.$store.state.dailyHusbandryStore.saving &&
                this.selectedTasks.length > 0 &&
                (!this.newWeightRequired || (this.newWeight && this.newWeight > 0)) &&
                (!this.newLocationRequired || (
                    this.newLocationTypeID && this.newRoomID && this.newSuiteNumberID && this.newDrawerID &&
                    this.newRackNumber &&
                    this.newLocationTypeID > 0 && this.newRoomID > 0 && this.newSuiteNumberID > 0 &&
                    this.newDrawerID > 0 && this.newRackNumber != ""
                ));
        },
        saveError() {
            return this.$store.state.dailyHusbandryStore.saveError;
        },
        saving() {
            return this.$store.state.dailyHusbandryStore.saving;
        }
    },
    methods: {
        datePickerFormat(date) {
            return moment.utc(date).format(constants.DATE_FORMAT_NO_TIME);
        },
        submitDailyHusbandry() {
            var that = this;

            // As the location data is prefilled, if we are not changing the location, clear it
            if (!this.newLocationRequired){
                this.newLocationTypeID = null;
                this.newRoomID = null;
                this.newDrawerID = null;
                this.newSuiteNumberID = null;
                this.newRackNumber = null;
            }

            this.$store.dispatch("dailyHusbandryStore/saveDailyHusbandry", {
                dailyHusbandry: {
                    specimenID: this.specimenID,
                    tasks: this.selectedTasks,
                    observations: this.selectedObservations,
                    date: this.husbandryDate,
                    dangerousOtherText: this.dangerousOtherText,
                    newWeight: this.newWeight,
                    newLocationTypeID: this.newLocationTypeID,
                    newRoomID: this.newRoomID,
                    newDrawerID: this.newDrawerID,
                    newSuiteNumberID: this.newSuiteNumberID,
                    newRackNumber: this.newRackNumber
                },
                finally: function() {
                    if (that.$store.state.dailyHusbandryStore.saveError) {
                        // display the error
                    }
                    else {
                        // Clear the data
                        that.selectedTasks = [];
                        that.selectedObservations = [];
                        that.dangerousOtherText = "";
                        that.newWeight = null;
                        that.newLocationTypeID = null;
                        that.newRoomID = null;
                        that.newDrawerID = null;
                        that.newSuiteNumberID = null;
                        that.newRackNumber = null;
                        that.husbandryDate = moment().format(constants.DATE_PICKER_FORMAT)

                        that.$emit("onSaved");
                    }
                }
            });
        }
    },
    created() {
        Promise.all([
            this.$store.dispatch("dailyHusbandryStore/loadDailyHusbandryTaskTypes"),
            this.$store.dispatch("dailyHusbandryStore/loadDailyHusbandryObservationTypes"),
            this.$store.dispatch("locationStore/loadLocationTypes"),
            this.$store.dispatch("locationStore/loadSuiteNumbers"),
            this.$store.dispatch("locationStore/loadRooms"),
            this.$store.dispatch("locationStore/loadDrawers")
        ]);
    }
};
</script>

<style>
</style>
